import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UserSessionService {
  private currentUserSubject: BehaviorSubject<any>;

  constructor(private router: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
  }

  /*
   * Get the current user data
   */
  get currentUser() {
    return this.currentUserSubject.value;
  }

  /*
   * Set the current user data
   */
  setCurrentUser(sessionId: string, currentUser: Object): void {
    localStorage.setItem('sessionId', sessionId);
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    this.currentUserSubject.next(currentUser);
  }

  /*
   * Delete the current user data and logout
   */
  delCurrentUser(): void {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sessionId');
    this.currentUserSubject.next(null);
    this.router.navigate(['/login']);
  }
}
